<template lang="pug">
div
  b-card
    .container-fluid
    .row
      .col-md-12
        .white-box
          h1.box-title.m-b-0 サイト設定編集
          p.text-muted.m-b-30.font-13 SWAN Proサイトのサイト設定の編集画面
          form.form-horizontal
            .form-group
              label.col-md-12 タイトル
              .col-md-12
                input.form-control(type='text', name='title', value='', placeholder='セクション名')
            .form-group
              label.col-md-12 HTMLソース
              .col-md-12
                textarea.form-control(rows='5')
              .form-group
                label(for='公開状態') 公開状態
                div
                  select.form-control
                    option 未公開（下書き）
                    option 承認依頼
                    option(selected='') 公開
                    option 公開終了
              .form-group
                label(for='承認を依頼したスタッフ') 承認を依頼したスタッフ
                input#exampleInputEmail1.form-control(type='text', placeholder='承認依頼時に指定したスタッフ名を表示')
              .form-group
                label(for='登録日時') 登録日時
                input#publish-date.form-control(type='text', placeholder='YYYY-MM-DD')
              .form-group
                label(for='更新日時') 更新日時
                input#appointed-date.form-control(type='text', placeholder='YYYY-MM-DD')
              .form-group
                label(for='公開予定日時') 公開予定日時
                input#appointed-date.form-control(type='text', placeholder='YYYY-MM-DD')
              .form-group
                label(for='公開終了日時') 公開終了日時
                input#appointed-date.form-control(type='text', placeholder='YYYY-MM-DD')
              .form-group
                label(for='登録ユーザー') 登録ユーザー
                input#appointed-date.form-control(type='text')
              .form-group
                label(for='承認ユーザー') 承認ユーザー
                input#appointed-date.form-control(type='text')
              button.btn.btn-success.waves-effect.waves-light.m-r-10(type='submit') 登録
              button.btn.btn-inverse.waves-effect.waves-light(type='submit') 確認

</template>

<script>
export default {
  name: 'Top',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/setting/edit.vue